﻿(function(){
  document.addEventListener('click', function(e){
    var summary = e.target.closest('details > summary');
    if(!summary) return;
    var details = summary.parentElement;
    var group = details.closest('[data-accordion-group]');
    if(!group) return;
    group.querySelectorAll('details[open]').forEach(function(item){ if(item !== details) item.removeAttribute('open'); });
  });
})();
